import { Box, Button, Checkbox, Chip, Divider, FormControl, FormControlLabel, FormGroup, Grid, InputLabel, MenuItem, OutlinedInput, Select, Typography } from '@mui/material';
import TuneIcon from '@mui/icons-material/Tune';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import {useState} from "react";
import './FilterButton.css';
import MultiSelectAccordian from "../MultiSelectAccordian";

interface FilterButtonProps {
   multiOptionSelection?: boolean;
   multiOptionData?: Record<string, Record<string, string>>;
   multiOptionFilters?: any;
   multiOptionHeaderLabels?: string[];
   handleMultiOptionChange?: (key, value) => void;
   showCards?: boolean;
   defaultSelection?: string[];
   values?: string[];
   cardsCount?: number;
   handleSelection?: (value: string[]) => void;
   name?: string;
   limitValue?: number;
}

const FilterButton = (props: FilterButtonProps) => {
  const { multiOptionSelection, multiOptionData, multiOptionFilters, multiOptionHeaderLabels, handleMultiOptionChange, showCards, defaultSelection, values, handleSelection, cardsCount, name, limitValue} = props;
  const [filterPopup, setFilterPopup] = useState(false);
  const [filtersOpen, setFiltersOpen] = useState(true);
  
  return (
    <div>
      <Grid item md={2} lg={2} className={filterPopup ? "l-shape filterBorder" : ''}>
          <Box className="filterButtonDiv" style={{ width: '100%', height: '100%' }}>
              <Button
                  variant="outlined"
                  startIcon={<TuneIcon  sx={{width: 16, height: 16}}/>}
                  onClick={() => setFilterPopup(prev => !prev)}
                  className="filter-button"
              >
              </Button>
          </Box>
      </Grid>
      {filterPopup && <Box className="filterPopup">
        {showCards && <MultiSelectAccordian defaultSelection={defaultSelection??[]} values={values??[]} handleSelection={handleSelection} cardsCount={cardsCount} name={name??""} limitValue={limitValue??0} />}
        <Grid className="filters-fields-container">
            <Checkbox size="small" sx={{ transform: "scale(0.8)" }} checked={filtersOpen} onChange={() => setFiltersOpen(!filtersOpen)} />
            <div className="fields-title-header">
                <span className="filter-fields-title">Filters</span>
                {filtersOpen ? (
                    <KeyboardArrowDownIcon onClick={() => setFiltersOpen(prevState => !prevState)} />
                ) : (
                    <KeyboardArrowUpIcon onClick={() => setFiltersOpen(prevState => !prevState)} />
                )}
            </div>
          </Grid>
          {filtersOpen && <div>
            {multiOptionSelection &&  multiOptionData && <div>
              <Grid className="multiOptionComponent">
                  <div className="Form">
                      <Grid className="am-table dash-filter-pop">
                          {multiOptionHeaderLabels?.map((headerLabel) => {
                              const headerkey = headerLabel.replace(/\s/g, "").toLowerCase();
                              const options: Record<string, string> = multiOptionData?.[headerkey];

                              return (

                                  <Grid key={headerkey}>
                                      <div className="filterHeader"><span >{headerLabel}</span></div>
                                      <FormGroup sx={{ padding: 0 }} className="filterOptionsDiv">
                                          {Object.entries(options).map(([optionKey, optionLabel]) => (
                                              <FormControlLabel
                                                  key={optionKey}
                                                  control={
                                                      <Checkbox
                                                          style={{ padding: "0px 8px" }}
                                                          checked={multiOptionFilters[headerkey]?.includes(optionKey) || multiOptionFilters[headerkey] === optionKey}
                                                          onChange={() => handleMultiOptionChange?.(headerkey, optionKey)}
                                                      />
                                                  }
                                                  label={optionLabel}
                                                  className="filterOptions"
                                              />
                                          ))}
                                      </FormGroup>
                                  </Grid>
                              );
                          })}
                      </Grid>
                  </div>
                </Grid>
            </div>}
          </div>}
        </Box>}
      </div>
  );
};

export default FilterButton;